/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Button, ButtonModule } from 'primeng/button';

@Component({
  selector: 'shared-ui-page-layout-with-right-panel',
  templateUrl: './page-layout-with-right-panel.component.html',
  styleUrls: ['./page-layout-with-right-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule]
})
export class PageLayoutWithRightPanelComponent {

  @Input() icon = 'ui-icon-edit'
  showPanelForMobile = false;

  onShowButton($event: MouseEvent) {
    this.showPanelForMobile = true;
    $event.stopPropagation();
  }

  onHideButton($event: MouseEvent) {
    this.showPanelForMobile = false;
    $event.stopPropagation();
  }
}
